import { Icon } from '@monorepo/base/src/components/icon/icon';
import styles from './sidebar.module.scss';
import { Sidebar, SidebarButton, SidebarMode } from '@monorepo/base/src/components/sidebar/sidebar';
import { IControlledStore, useStores } from '@monorepo/controlled/src/hooks/use-stores';
import routes from '../../routes/index.routes'; // TODO - need to be dynamic
import { observer } from 'mobx-react';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { LinkWithParams } from '@monorepo/base/src/components/link-with-params/link-with-params';
import { Guard } from '../guard/guard';
import { useGuard, validateAction } from '../../hooks/tools/use-guard';
import { PermissionActions } from '../../enums/permissions';
import { useEffect } from 'react';
import { sendGtagEvent } from '@monorepo/tools/src/lib/tools/tracking';
import { EVENTS } from '@monorepo/tools/src/lib/consts/tracking/events';
import { TrackingActions } from '@monorepo/tools/src/lib/consts/tracking/actions';

interface IItemList {
	mini?: boolean;
	title?: JSX.Element | string;
	route: string; // TODO - one of the routes
	icon?: string;
	color?: string;
}

// TODO - @MFP remove it from controlled
export const ControlledSidebar = observer(() => {
	const { sidebarStore } = useStores<IControlledStore>();

	const isHasUsersPermission = useGuard({ validate: validateAction([PermissionActions.UsersRead]) });

	useEffect(() => {
		if (isHasUsersPermission) {
			sidebarStore.setSidebarOpen(true);
		}
	}, [isHasUsersPermission]);

	const ItemList = ({ mini = false, title, route, icon, color }: IItemList) => {
		const { indexRoute, currentRoute } = useRoute();
		const isActiveRoute = currentRoute === route || currentRoute === `/${route}` || indexRoute === route;
		return (
			<li className={`${styles.itemWrapper} ${isActiveRoute ? styles.activeItem : ''}`}>
				<LinkWithParams
					onClick={() => {
						sendGtagEvent({
							action: TrackingActions.Click,
							category: EVENTS.CLICK.SIDEBAR.ITEM,
							label: mini ? 'Minified' : 'Normal',
							value: title as string,
						});
					}}
					to={route}
					className={styles.itemLink}>
					<div className={styles.item}>
						{icon ? (
							<Icon className={styles.icon} isMFP={true} color={color} size={'22px'}>
								{icon}
							</Icon>
						) : null}

						{mini ? null : <span className={styles.itemTitle}>{title}</span>}
					</div>
				</LinkWithParams>
			</li>
		);
	};

	const isMiniSidebar = (isHover: boolean) => {
		return (
			(!isHover && sidebarStore.getSidebarMode() === SidebarMode.HOVER) ||
			(!sidebarStore.getIsSideBarOpen() && sidebarStore.getSidebarMode() === SidebarMode.LOCK)
		);
	};

	const onClickSidebarButton = () => {
		sendGtagEvent({
			action: TrackingActions.Click,
			category: EVENTS.CLICK.SIDEBAR.TOGGLE,
			value: !sidebarStore.getIsSideBarOpen() ? 'Maximize' : 'Minimize',
		});
		sidebarStore.setSidebarOpen(!sidebarStore.getIsSideBarOpen());
		sidebarStore.setSidebarMode(SidebarMode.LOCK);
	};

	const isSidebarOpen = sidebarStore.getIsSideBarOpen();

	return (
		<Sidebar
			isOpen={sidebarStore.getIsSideBarOpen()}
			isAnimate={sidebarStore.getIsSideBarAnimate() || sidebarStore.getSidebarMode() === SidebarMode.HOVER}
			mode={sidebarStore.getSidebarMode()}>
			{props => {
				const { isHover } = props;
				const _isMiniSidebar = isMiniSidebar(isHover);
				return (
					<div className={styles.wrapper}>
						<ul className={`${styles.list} ${styles.fullList}`}>
							<ItemList
								icon={'bar-chart-square-02'}
								route={routes.reports.index()}
								title={'Statistical Report'}
								mini={_isMiniSidebar}
							/>
							<Guard validate={validateAction([PermissionActions.ReportRead])}>
								<ItemList icon={'package'} route={routes.inventory.index()} title={'Inventory'} mini={_isMiniSidebar} />
							</Guard>
							<Guard validate={validateAction([PermissionActions.ReportRead])}>
								<ItemList icon={'link-01'} route={routes.myLinks.index()} title={'My Links'} mini={_isMiniSidebar} />
							</Guard>
							<Guard validate={validateAction([PermissionActions.BillingRead, PermissionActions.BillingWrite])}>
								<ItemList
									icon={'coins-stacked-02'}
									route={routes.billing.index()}
									title={'Billing'}
									mini={_isMiniSidebar}
								/>
							</Guard>
							<Guard validate={validateAction([PermissionActions.UsersRead])}>
								<ItemList icon={'users-03'} route={routes.usersManagement.index()} title={'Users'} mini={_isMiniSidebar} />
							</Guard>
						</ul>
						<SidebarButton
							classes={{ button: `${styles.hamburgerSidebar} ${isSidebarOpen ? `${styles.openSidebar}` : ''}` }}
							onClick={onClickSidebarButton}
							isOpen={isSidebarOpen}
							icon={'align-right-01'}
						/>
					</div>
				);
			}}
		</Sidebar>
	);
});
